var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 11.458h35.75c1.518 0 2.75 1.27 2.75 2.834v25.5c0 1.564-1.232 2.833-2.75 2.833H4.125c-1.518 0-2.75-1.27-2.75-2.833v-25.5c0-1.564 1.232-2.834 2.75-2.834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 32.103V20.08a2.725 2.725 0 0 1 2.25-2.705A77 77 0 0 1 22 16.5c4.308-.07 8.615.224 12.876.875a2.73 2.73 0 0 1 2.25 2.706v12.022a2.74 2.74 0 0 1-2.293 2.716c-4.246.65-8.537.962-12.833.931a81 81 0 0 1-12.824-.931 2.74 2.74 0 0 1-2.301-2.716m11.458-30.27L26.125 11l5.958-9.167"
  }))));
};
export default SvgTv;